import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import { LoadingBoxComponent } from '@shared/components/loading-box/loading-box.component';
import { AlertService, AlertType } from '@shared/services/alert.service';
import { ProcessoVendaService } from '@shared/services/apis/vendas/processo-venda.service';
import { ContasReceberVendaLancadaStruct } from '@shared/services/structs/financas/contas-receber-venda-lancada.struct';
import { MovimentacaoVendaLancadaStruct } from '@shared/services/structs/financas/movimentacao-venda-lancada.struct';

import { PvFinanceiroLancamentosComponent } from '../../components/pv-financeiro-lancamentos/pv-financeiro-lancamentos.component';

export interface PvFinanceiroDialogData {
    idVenda: number;
    /** "Pedido de Venda nº 123" — o rótulo do cabeçalho. */
    rotuloDocumento: string;
}

/**
 * Lançamentos do financeiro do pedido, só para consultar: os títulos e as movimentações que o Finanças tem,
 * com a situação de cada um e o link para o registro (nova aba). Aberto pela faixa do documento e pelo
 * indicador F do board.
 */
@Component({
    selector: 'app-pv-financeiro-dialog',
    standalone: true,
    imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, LoadingBoxComponent, PvFinanceiroLancamentosComponent],
    templateUrl: './pv-financeiro-dialog.component.html',
    styleUrls: ['./pv-financeiro-dialog.component.css'],
})
export class PvFinanceiroDialogComponent implements OnInit {
    public isLoading = true;
    public contas: ContasReceberVendaLancadaStruct[] = [];
    public movimentacoes: MovimentacaoVendaLancadaStruct[] = [];

    constructor(
        public dialogRef: MatDialogRef<PvFinanceiroDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: PvFinanceiroDialogData,
        private processoVendaService: ProcessoVendaService,
        private alertService: AlertService,
    ) {}

    /** Sem o que o Finanças tem do pedido não há o que mostrar: avisa por toast e fecha. */
    public ngOnInit(): void {
        this.processoVendaService.getFinanceiro(this.data.idVenda).subscribe({
            next: (res) => {
                this.isLoading = false;

                if (res.isError) {
                    this.alertService.show('Aviso', res.errorDescription || 'Não foi possível consultar o financeiro do pedido.', AlertType.warning);
                    this.dialogRef.close();
                    return;
                }

                this.contas = res.contas ?? [];
                this.movimentacoes = res.movimentacoes ?? [];
            },
            error: () => {
                this.isLoading = false;
                this.alertService.show('Aviso', 'Não foi possível consultar o financeiro do pedido agora. Tente novamente em alguns instantes.', AlertType.warning);
                this.dialogRef.close();
            },
        });
    }

    public get temFinanceiro(): boolean {
        return this.contas.length > 0 || this.movimentacoes.length > 0;
    }

    public fechar(): void {
        this.dialogRef.close();
    }
}
